import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useDeletePoll = () => {
  const deletePoll = useCallback((id) => {
    const requestParams = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    const url = `${API_BASE_URL}/api/v3/activity/${id}/`;
    return new Request(url, requestParams);
  }, []);
  return useRestMutation(deletePoll);
};

export default useDeletePoll;
